import React from 'react';
import Typography from 'new/elements/TypographySupport';

import { Paper } from '@mui/material';

const styles = {
  rootDiv: {
    display: 'flex',
    height: '80vh',
    flexDirection: 'column',
    padding: '100px 86px 0',
    justifyContent: 'space-between  ',
  },

  titleDiv: {
    textAlign: 'center',
    backgroundColor: 'rgba(255,255,255,0)',
  },

  subtitleText: {
    marginTop: 24,
    fontSize: 14,
  },
  tip: {
    alignSelf: 'center',
    textAlign: 'center',
    padding: 16,
    fontSize: 14,
    backgroundColor: 'rgb(255,255,255)',
  },
};

class NoContentTextView extends React.Component {
  render() {
    return (
      <div
        data-testid="no-content-text-view"
        style={{ ...styles.rootDiv, ...this.props.rootStyle }}
      >
        <Paper elevation={0} style={styles.titleDiv}>
          <Typography color="disabled.contrastText" variant="h5">
            {this.props.title}
          </Typography>
          {this.props.subtitle && <div style={styles.subtitleText}>{this.props.subtitle}</div>}
        </Paper>
        {this.props.tipText && (
          <Paper elevation={2} style={styles.tip}>
            <div>
              <b>Tip:</b> {this.props.tipText}
            </div>
          </Paper>
        )}
      </div>
    );
  }
}

NoContentTextView.defaultProps = {
  tipText: null,
};

export default NoContentTextView;
